import type { MouseEventHandler } from 'react';
import { IconPlayButton } from '@/assets/icons/IconPlayButton';
import { Button } from '@/ui-components/atoms/Button/Button';

export interface SportsListenLiveProps {
    name: string;
    href?: string;
    onClick?: MouseEventHandler;
}

export function SportsListenLive({ name, href, onClick }: SportsListenLiveProps) {
    return (
        <Button
            type="button"
            variant="primary"
            size="x-small"
            iconButton
            disableHoverGrow
            href={href}
            linkTarget="_blank"
            ariaLabel={`Listen live to ${name}`}
            onClick={onClick}
        >
            <span aria-hidden="true">
                <IconPlayButton fill="currentColor" />
            </span>
        </Button>
    );
}
